const       ProductListColConfig = {
  CO : [
    {
      name_of_db_column: 'productId',
      label_of_column: 'Product ID',
      order_of_column: 1,
    },
    {
      name_of_db_column: 'status',
      label_of_column: 'Status',
      order_of_column: 2,
    },
    {
      name_of_db_column: 'productName',
      label_of_column: 'Product Name',
      order_of_column: 3,
    },
    {
      name_of_db_column: 'segmentCount',
      label_of_column: 'Segment Count',
      order_of_column: 4,
      filterVariant: 'long',
    },
    {
      name_of_db_column: 'displayName_en',
      label_of_column: 'Display Name (English)',
      order_of_column: 5,
    },
    {
      name_of_db_column: 'subCategoryCount',
      label_of_column: 'Subcategory Count',
      order_of_column: 6,
      filterVariant: 'long',
    },
    {
      name_of_db_column: 'sorting',
      label_of_column: 'Sorting',
      order_of_column: 7,
    },
    {
      name_of_db_column: 'showOnECommerce',
      label_of_column: 'Show on e-commerce',
      order_of_column: 8,
    },
    {
      name_of_db_column: 'suggestedProductSellingPrice',
      label_of_column: 'Suggested Product Selling Price',
      order_of_column: 9,
      filterVariant: 'double',
    },
    {
      name_of_db_column: 'multipleSellingUnits',
      label_of_column: 'Multiple Selling Units',
      order_of_column: 10,
    },
  ],
  IND : [
      {
      name_of_db_column: 'productId',
      label_of_column: 'Product ID',
      order_of_column: 1,
    },
    {
      name_of_db_column: 'status',
      label_of_column: 'Status',
      order_of_column: 2,
    },
    {
      name_of_db_column: 'segmentCount',
      label_of_column: 'Segment Count',
      order_of_column: 2,
      filterVariant: 'long',
    },
    {
      name_of_db_column: 'productName',
      label_of_column: 'Product Name',
      order_of_column: 3,
    },
    {
      name_of_db_column: 'displayName_en',
      label_of_column: 'Display Name (English)',
      order_of_column: 4,
    },
    {
      name_of_db_column: 'imageAvailability',
      label_of_column: 'Image Availability',
      order_of_column: 5,
    },
    {
      name_of_db_column: 'subCategoryCount',
      label_of_column: 'Subcategory Count',
      order_of_column: 6,
      filterVariant: 'long',
    },
    {
      name_of_db_column: 'sorting',
      label_of_column: 'Sorting',
      order_of_column: 7,
    },
    {
      name_of_db_column: 'showOnECommerce',
      label_of_column: 'Show on e-Commerce',
      order_of_column: 8,
    },
    {
      name_of_db_column: 'suggestedProductSellingPrice',
      label_of_column: 'Suggested Product Selling Price',
      order_of_column: 9,
      filterVariant: 'double',
    },
    {
      name_of_db_column: 'multipleSellingUnits',
      label_of_column: 'Multiple Selling Units',
      order_of_column: 10,
    },
  ],
  MX : [
      {
      name_of_db_column: 'productId',
      label_of_column: 'Product ID',
      order_of_column: 1,
    },
    {
      name_of_db_column: 'status',
      label_of_column: 'Status',
      order_of_column: 2,
    },
    {
      name_of_db_column: 'segmentCount',
      label_of_column: 'Segment Count',
      order_of_column: 2,
      filterVariant: 'long',
    },
    {
      name_of_db_column: 'productName',
      label_of_column: 'Product Name',
      order_of_column: 3,
    },
    {
      name_of_db_column: 'displayName_en',
      label_of_column: 'Display Name (English)',
      order_of_column: 4,
    },
    {
      name_of_db_column: 'subCategoryCount',
      label_of_column: 'Subcategory Count',
      order_of_column: 5,
      filterVariant: 'long',
    },
    {
      name_of_db_column: 'sorting',
      label_of_column: 'Sorting',
      order_of_column: 6,
    },
    {
      name_of_db_column: 'showOnECommerce',
      label_of_column: 'Show on e-Commerce',
      order_of_column: 7,
    },
    {
      name_of_db_column: 'suggestedProductSellingPrice',
      label_of_column: 'Suggested Product Selling Price',
      order_of_column: 8,
      filterVariant: 'double',
    },
    {
      name_of_db_column: 'multipleSellingUnits',
      label_of_column: 'Multiple Selling Units',
      order_of_column: 9,
    },
  ]
}


export const  CountryProductListColConfig = countryCode => {
  switch (countryCode) {
    case 'IND':
      return ProductListColConfig.IND
    case 'CO':
      return ProductListColConfig.CO
    default:
      return ProductListColConfig.MX
  }
}
